import ExclamationmarkTriangle from './ExclamationmarkTriangle';

export default ExclamationmarkTriangle;
